import IconsTextNavigation from 'components/global/IconsTextNavigation'
import AgreementsModal from 'pages/Events/Views/Common/Modals/AgreementsModal'
import React, { useState } from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'

const Agreements: React.FC = () => {
  const [agreementsModal, setAgreementsModal] = useState<boolean>(false)
  const { leagueData, agreements, setAgreements } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    agreements: store.agreements,
    setAgreements: store.setAgreements,
  }))
  return (
    <>
      <div onClick={() => setAgreementsModal(true)}>
        <IconsTextNavigation
          iconName="Checks"
          heading="Agreements"
          isCompleted={agreements.length > 0 ? true : false}
        />
      </div>

      {agreementsModal && (
        <AgreementsModal
          modalOpen={agreementsModal}
          setModalOpen={setAgreementsModal}
          type="league"
          entityId={leagueData._id}
          selectedAgreementsIds={agreements}
          setSelectedAgreementsIds={setAgreements}
        />
      )}
    </>
  )
}

export default Agreements
